function setViewportHeight() {
    document.documentElement.style.setProperty(
        '--vh',
        window.innerHeight / 100 + 'px'
    );
}
